import Vue from 'vue'
// import Config from '../config'
import Router from '../router'
// import JsAction from '@/js/JsAction' // 调用app方法
import { getApi, postApi } from '../api'

const jsCallBack = {
  // scanQRCode: function (msg) {
  //   // Vue.$vux.alert.show({
  //   //   title: '二维码',
  //   //   content: msg
  //   // })
  //   const basePath = Config.base_path
  //   const url = msg.split('/#/')
  //   if (msg.includes(basePath)) {
  //     let paramsStrimg = ''
  //     let router = ''
  //     if (url[1]) {
  //       router = url[1].split('?')[0]
  //       paramsStrimg = url[1].split('?')[1]
  //       let params = querystring.parse(paramsStrimg)
  //       Router.push({
  //         name: router,
  //         query: params
  //       })
  //     } else {
  //       Router.push('/')
  //     }
  //   } else {
  //     let Params = {'url': msg}
  //     let _Params = JSON.stringify(Params)
  //     let jsRequest = {'ActionName': 'openLink', 'Callback': '', 'Params': _Params}
  //     JsAction.doAction(jsRequest)
  //   }
  //   // window.location.href = msg
  // },
  saveScreen: function (msg) {
    Vue.$vux.alert.show({
      title: '保存成功',
      content: '海报已保存在相册'
    })
  },
  wxappPayOnline: function (data) { // 微信支付回调 线上
    if (+data === 0) {
      this.$vux.toast.text('支付成功', 'midden')
      this.$router.push({
        name: 'myOrder'
      })
    }
  },
  appPayOnline: function (data) { // 支付宝支付回调 线上
    if (+data === 9000) {
      this.$vux.toast.text('支付成功', 'midden')
      this.$router.push({
        name: 'myOrder'
      })
    }
  },
  appPaySetIn () {
    Vue.$vux.toast.text('支付成功', 'midden')
    Router.back()
  },
  weixiLogin: function (params) {
    const uid = JSON.parse(params).unionid
    getApi('public/wechatLogin', {
      // unionid: 'oJDrtvvgiwd6nvuWtkhQw_-Q6BJM'
      unionid: uid
    }).then(data => {
      if (data.code === 0) {
        if (data.content.is_bind) {
          window.localStorage.userData = JSON.stringify(data.content.userinfo)
          Vue.$vux.toast.text('登录成功', 'midden')
          Router.push('/')
        } else {
          Vue.$vux.toast.text('您的微信号暂未绑定，可登录后绑定', 'midden')
        }
      } else {
        Vue.$vux.toast.text(data.message, 'midden')
      }
    }).catch(err => {
      console.log(err)
    })
  },
  weixBind: function (params) { // 绑定微信
    const token = JSON.parse(window.localStorage.userData).token
    Vue.$vux.alert.show({
      title: '保存成功',
      content: JSON.parse(params).unionid
    })
    const uid = JSON.parse(params).unionid
    postApi('User/bindWechat', {
      token: token,
      unionid: uid
    }).then(data => {
      // window.alert(JSON.stringify(data))
      if (data.code === 0) {
        if (data.content.is_ok) {
          Vue.$vux.toast.text('绑定成功', 'midden')
          Vue.msg.unionid = uid
        } else {
          Vue.$vux.toast.text(data.message, 'midden')
        }
      } else {
        Vue.$vux.toast.text(data.message, 'midden')
      }
    })
  }
}

export default jsCallBack



// WEBPACK FOOTER //
// ./src/js/jsCallBack.js